export default "__VITE_ASSET__a321418b__"